const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://api.inventyacloud.co.uk";

export default {
    XeroUrl: API_BASE_URL,
    ApiUrl: `${API_BASE_URL}/api`,
    ApiAdminUrl: `${API_BASE_URL}/api/admin`,
};
